import { render, staticRenderFns } from "./AccountRoleListPage.vue?vue&type=template&id=4079014e&scoped=true"
import script from "./AccountRoleListPage.vue?vue&type=script&lang=js"
export * from "./AccountRoleListPage.vue?vue&type=script&lang=js"
import style0 from "./AccountRoleListPage.vue?vue&type=style&index=0&id=4079014e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4079014e",
  null
  
)

export default component.exports